var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 27,
    viewBox: "0 0 15 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.573599 25.4855C0.206324 25.1181 0 24.6199 0 24.1004C0 23.5809 0.206324 23.0827 0.573599 22.7153L10.2711 13.0178L0.573599 3.32022C0.216732 2.95073 0.0192653 2.45585 0.0237289 1.94218C0.0281926 1.42851 0.23423 0.937144 0.597463 0.573911C0.960696 0.210678 1.45206 0.00464367 1.96573 0.000180018C2.4794 -0.00428364 2.97428 0.193183 3.34377 0.550049L14.4264 11.6327C14.7937 12.0001 15 12.4983 15 13.0178C15 13.5372 14.7937 14.0355 14.4264 14.4028L3.34377 25.4855C2.97638 25.8528 2.47817 26.0591 1.95868 26.0591C1.4392 26.0591 0.940984 25.8528 0.573599 25.4855Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.85e142a7759bafdb5d83e168f72d58e0.svg";
export { ForwardRef as ReactComponent };